import React, { Component } from "react";
// modal,Button via react bootstrap
import { Modal, Button } from "react-bootstrap";
//API handling components
import { BASE_URL } from "./../common/global.js";
//react toast
import { toast } from "react-toastify";
import iclmLogo from "../invoices/assets/iclmLogo.jpeg";
import "./style.css";
import { Link } from "react-router-dom";
import { AuthContext } from "../../Context/authContext";
import TextField from "@mui/material/TextField";

// datatablse packages
var $ = require("jquery");
$.DataTable = require("datatables.net");
require("datatables.net-bs4");
require("datatables.net-autofill-bs4");
require("datatables.net-buttons-bs4");
require("datatables.net-buttons/js/buttons.colVis");
require("datatables.net-buttons/js/buttons.flash");
require("datatables.net-buttons/js/buttons.html5");
require("datatables.net-buttons/js/buttons.print");
require("datatables.net-responsive-bs4");
require("datatables.net-scroller-bs4");
require("datatables.net-select-bs4");
require("pdfmake");

// Axios for HTTP req
const axios = require("axios");

export default class Candidate extends Component {
    constructor(props) {
        super(props);
        this.state = {
            candidates: null,
            selectedFile: null,
            activeDocPath: null,
            // z@@j9blB
            // .\consultant
            newCandidate: {
                firstName: null,
                lastName: null,
                email: null,
                address: null,
                mobileNo: null,
                companyName: null,
                department: null,
                designation: null,
                alignment: 1,
                selectedFile: null,
                status: null,
            },
            firstNameError: null,
            lastNameError: null,
            emailError: null,
            addressError: null,
            mobileNoError: null,
            companyNameError: null,
            departmentError: null,
            designationError: null,
            alignmentError: 1,
            selectedFileError: null,

            currentCandidate_id: null,
            currentCandidate_firstName: null,
            currentCandidate_lastName: null,
            currentCandidate_address: null,
            currentCandidate_email: null,
            currentCandidate_department: null,
            currentCandidate_designation: null,
            currentCandidate_mobileNo: null,
            currentCandidate_companyName: null,
            currentCandidate_selectedFile: null,

            updateModal: false,
            viewModal: false,
        };
    }

    // handleChange(event, alignment) {
    //     // this.setState(alignment);
    // };

    // pdf maker

    refresh() {
        window.location.reload(false);
    }

    onChangeCandidateFirstName(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.firstName = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeCandidateLastName(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.lastName = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }
    onChangeCandidateAddress(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.address = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeCandidateEmail(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.email = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeCandidateMobileNo(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.mobileNo = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeComapanyName(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.companyName = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeCandidateDepartment(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.department = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    onChangeCandidateDesignation(e) {
        let newCandidate = this.state.newCandidate;
        newCandidate.designation = e.target.value;
        this.setState({ newCandidate: newCandidate });
    }

    validate() {
        let status = true;
        if ( this.state.newCandidate.firstName == null) {
            this.setState({ firstNameError: "please fill up the field" });
            console.log(this.state.firstNameError)
            status = false;
        }
        if ( this.state.newCandidate.lastName == null) {
            this.setState({ lastNameError: "please fill up the field" });
            console.log(this.state.lastNameError)
            status = false;
        }
        if ( this.state.newCandidate.companyName == null) {
            this.setState({ companyNameError: "please fill up the field" });
            console.log(this.state.companyNameError)
            status = false;
        }
        if ( this.state.newCandidate.mobileNo == null) {
            this.setState({ mobileNoError: "please fill up the field" });
            console.log(this.state.mobileNoError)
            status = false;
        }
        if ( this.state.newCandidate.address == null) {
            this.setState({ addressError: "please fill up the field" });
            console.log(this.state.addressError)
            status = false;
        }
        if ( this.state.newCandidate.email == null) {
            this.setState({ emailError: "please fill up the field" });
            console.log(this.state.emailError)
            status = false;
        }
        if ( this.state.newCandidate.designation == null) {
            this.setState({ designationError: "please fill up the field" });
            console.log(this.state.designationError)
            status = false;
        }
        if ( this.state.newCandidate.department == null) {
            this.setState({ departmentError: "please fill up the field" });
            console.log(this.state.departmentError)
            status = false;
        }
        return status;

    }

    handleInputChange = (event) => {
        this.setState({
            selectedFile: event.target.files[0],
        });
    };

    submitFile() {
        const data = new FormData();
        data.append("fileToUpload", this.state.selectedFile);
        let url = "https://iclm.5techg.com/api/fileUpload/";

        axios.post(url, data).then((res) => {
            // then print response status
            

            this.setState({ activeDocPath: res.data }, this.onSubmit);
            
        }); 
    }

    onSubmit(e) {
        if(this.validate()){
        let url = BASE_URL;
        const query =
            'INSERT INTO candidateMaster (firstName, lastName, emailId, address, mobileNo, companyName, designation, department, filePath) values("' +
            this.state.newCandidate.firstName +
            '","' +
            this.state.newCandidate.lastName +
            '","' +
            this.state.newCandidate.address +
            '", "' +
            this.state.newCandidate.email +
            '", "' +
            this.state.newCandidate.mobileNo +
            '", "' +
            this.state.newCandidate.companyName +
            '", "' +
            this.state.newCandidate.designation +
            '", "' +
            this.state.newCandidate.department +
            '", "' +
            this.state.activeDocPath +
            '") ';
        console.log(query);
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                toast("new Candidate added!");
                setTimeout(this.refresh, 1000);
            })
            .catch((error) => {
                toast.error("Something Went Wrong!");
            });

        this.setState({
            firstName: "",
            lastName: "",
            address: "",
            email: "",
            mobileNo: "",
            companyName: "",
            designation: "",
            department: "",
        });
    }
    }

    submitUserUpdate(e) {
        let url = BASE_URL;
        const query =
            'UPDATE candidateMaster SET firstName = "' +
            this.state.currentCandidate_firstName +
            '",lastName = "' +
            this.state.currentCandidate_lastName +
            '", emailId = "' +
            this.state.currentCandidate_email +
            '",  address = "' +
            this.state.currentCandidate_address +
            '", mobileNo = "' +
            this.state.currentCandidate_mobileNo +
            '", companyName = "' +
            this.state.currentCandidate_companyName +
            '", designation = "' +
            this.state.currentCandidate_designation +
            '", department = "' +
            this.state.currentCandidate_department +
            '" WHERE id = ' +
            this.state.currentCandidate_id +
            "";
        console.log(query);
        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                toast("candidate updated successfully!");
                setTimeout(this.refresh, 1000);
            })
            .catch((error) => {
                toast.error("Something Went Wrong!");
            });

        this.setState({
            firstName: "",
            lastName: "",
            address: "",
            email: "",
            mobileNo: "",
            companyName: "",
            designation: "",
            department: "",
        });
    }

    submitUserDelete(id) {
        let url = BASE_URL;
        const query = `UPDATE candidateMaster SET status = -1 where id = ${id};`;

        let data = { crossDomain: true, crossOrigin: true, query: query };
        axios
            .post(url, data)
            .then((res) => {
                toast("candidate deleted successfully!");
                setTimeout(this.refresh, 1000);
            })
            .catch((error) => {
                toast.error("Something Went Wrong!");
            });

        this.setState({
            firstName: "",
            lastName: "",
            address: "",
            email: "",
            mobileNo: "",
            companyName: "",
            designation: "",
            department: "",
        });
    }

    fetchCandidateData() {
        let url = BASE_URL;
        const query = `SELECT * FROM candidateMaster where status = 1;`;
        let data = { crossDomain: true, crossOrigin: true, query: query };

        axios
            .post(url, data)
            .then((res) => {
                this.setState({ candidates: res.data });
            })
            .catch((err) => { });
    }

    // handleInputChange = (event) => {
    //     this.setState({
    //         selectedFile: event.target.files[0],
    //     });
    // };

    componentDidMount() {
        this.fetchCandidateData();
    }

    componentDidUpdate() {
        $(document).ready(function () {
            $("#example1")
                .DataTable({
                    bSort: true,

                    destroy: true,
                    responsive: true,
                    lengthChange: false,
                    autoWidth: false,
                    buttons: ["copy", "csv", "excel", "print"],
                    exportOptions: {
                        columns: "th:not(:last-child)",
                    },
                })
                .buttons()
                .container()
                .appendTo("#example1_wrapper .col-md-6:eq(0)");
        });
    }

    renderCandidatesData() {
        const candidates = this.state.candidates;

        if (candidates == null) {
            return null;
        }

        return candidates.map((candidate) => {
            // define user type
            // let userType = ["Admin", "Engineer", "Accountant", "Partner"][
            //     user.type - 1
            // ];
            return (
                <tr>
                    <td>{candidate.id}</td>
                    <td>{candidate.firstName}</td>
                    <td>{candidate.lastName}</td>
                    <td>{candidate.companyName}</td>
                    <td>{candidate.mobileNo}</td>
                    <td>{candidate.address}</td>
                    <td>{candidate.emailId}</td>
                    <td>{candidate.designation}</td>
                    <td>{candidate.department}</td>
                    <td>
                    <a
                            href={`${candidate.filePath}`}
                            target="_blank"
                            class="btn btn-primary btn-sm mx-1"
                            // download
                        >
                            <i class="fas fa-eye"></i>
                        </a>
                    </td>

                    {/* <td>{userType}</td> */}
                    <td className="" style={{ width: "150px" }}>
                        <button
                            class="btn btn-primary btn-sm mr-1"
                            onClick={() => {
                                this.setState({
                                    currentCandidate_id: candidate.id,
                                    currentCandidate_firstName:
                                        candidate.firstName,
                                    currentCandidate_lastName:
                                        candidate.lastName,
                                    currentCandidate_address: candidate.address,
                                    currentCandidate_mobileNo:
                                        candidate.mobileNo,
                                    currentCandidate_companyName:
                                        candidate.companyName,
                                    currentCandidate_email: candidate.emailId,
                                    currentCandidate_designation:
                                        candidate.designation,
                                    currentCandidate_department:
                                        candidate.department,
                                    viewModal: true,
                                });
                            }}
                        >
                            <i class="fas fa-eye"></i>
                        </button>

                        <button
                            class="btn btn-primary btn-sm mr-1"
                            onClick={(e) => {
                                this.setState({
                                    currentCandidate_id: candidate.id,
                                    currentCandidate_firstName:
                                        candidate.firstName,
                                    currentCandidate_lastName:
                                        candidate.lastName,
                                    currentCandidate_address: candidate.address,
                                    currentCandidate_mobileNo:
                                        candidate.mobileNo,
                                    currentCandidate_companyName:
                                        candidate.companyName,
                                    currentCandidate_email: candidate.emailId,
                                    currentCandidate_designation:
                                        candidate.designation,
                                    currentCandidate_department:
                                        candidate.department,
                                    updateModal: true,
                                });
                            }}
                        >
                            <i class="fas fa-user-edit"></i>
                        </button>

                        <button
                            class="btn btn-danger btn-sm"
                            onClick={(e) => {
                                if (
                                    window.confirm(
                                        "Really want to delete user?"
                                    )
                                ) {
                                    this.submitUserDelete(candidate.id);
                                }
                            }}
                        >
                            <i class="fas fa-trash-alt"></i>
                        </button>
                    </td>
                </tr>
            );
        });
    }

    //   Render view modal starts here (view button)

    renderViewModal() {
        return (
            <Modal
                show={this.state.viewModal}
                onHide={() => {
                    this.setState({ viewModal: false });
                }}
                size="md"
            >
                <Modal.Header closeButton>
                    <Modal.Title>Certificate</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                First Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_firstName}
                                value={this.state.currentCandidate_firstName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_firstName:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                Last Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_lastName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_lastName:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteEngineers"
                                className="col-form-label"
                            >
                                Mobile No:
                            </label>
                            <input
                                type="text"
                                name="Engineers"
                                value={this.state.currentCandidate_mobileNo}
                                className="form-control"
                                id="siteEngineers"
                                placeholder="1, 2, 3"
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_mobileNo:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                Address:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_address}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_address:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Email:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_email}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_email: e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Company Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_companyName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_companyName:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Designation:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_designation}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_designation:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Department:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_department}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_department:
                                            e.target.value,
                                    });
                                }}
                                readOnly
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            this.setState({ viewModal: false });
                        }}
                    >
                        Close
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    //   Render view modal ends here (view button)

    // modal for update user starts here

    renderUpdateModal() {
        return (
            <Modal
                show={this.state.updateModal}
                onHide={() => {
                    this.setState({ updateModal: false });
                }}
            >
                <Modal.Header closeButton>
                    <Modal.Title>Update User</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                First Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_firstName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_firstName:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                Last Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_lastName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_lastName:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteEngineers"
                                className="col-form-label"
                            >
                                Mobile No:
                            </label>
                            <input
                                type="text"
                                name="Engineers"
                                value={this.state.currentCandidate_mobileNo}
                                className="form-control"
                                id="siteEngineers"
                                placeholder="1, 2, 3"
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_mobileNo:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteName"
                                className="col-form-label"
                            >
                                Address:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_address}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_address:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Email:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_email}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_email: e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Company Name:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_companyName}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_companyName:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Designation:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_designation}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_designation:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="form-group">
                            <label
                                htmlFor="siteAddress"
                                className="col-form-label"
                            >
                                Department:
                            </label>
                            <input
                                type="text"
                                name="name"
                                className="form-control"
                                id="siteName"
                                value={this.state.currentCandidate_department}
                                onChange={(e) => {
                                    this.setState({
                                        currentCandidate_department:
                                            e.target.value,
                                    });
                                }}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="secondary"
                        onClick={() => {
                            this.setState({ updateModal: false });
                        }}
                    >
                        Close
                    </Button>
                    <Button
                        variant="primary"
                        onClick={(e) => {
                            this.submitUserUpdate(e);
                            this.setState({ updateModal: false });
                        }}
                    >
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    }

    //modal for update user ends here

    render() {
        return (
            <div>
                {/* Content Wrapper. Contains page content */}
                <div className="content-wrapper" style={{ height: "auto" }}>
                    {/* Main content */}
                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12">
                                    <div class="mt-2">
                                        {/* add new user modal */}
                                        <div className="add">
                                            <button
                                                type="button"
                                                class=" new btn btn-primary btn-sm mb-2 mr-2"
                                                data-toggle="modal"
                                                data-target="#exampleModal"
                                                data-whatever="@mdo"
                                            >
                                                <span>
                                                    <i class="fas fa-user-plus"></i>
                                                </span>
                                                &nbsp;Add New Candidate
                                            </button>

                                            <div
                                                className="modal fade"
                                                id="exampleModal"
                                                tabIndex={-1}
                                                role="dialog"
                                                aria-labelledby="exampleModalLabel"
                                                aria-hidden="true"
                                            >
                                                <div
                                                    className="modal-dialog"
                                                    role="document"
                                                >
                                                    <div className="modal-content">
                                                        <div className="modal-header">
                                                            <h5
                                                                className="modal-title"
                                                                id="exampleModalLabel"
                                                            >
                                                                Add New
                                                                Candidate
                                                                {/*  */}
                                                            </h5>
                                                            <button
                                                                type="button"
                                                                className="close "
                                                                data-dismiss="modal"
                                                                aria-label="Close"
                                                            >
                                                                <span aria-hidden="true">
                                                                    ×
                                                                </span>
                                                            </button>
                                                        </div>
                                                        <div className="modal-body">
                                                            <form>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="message-text"
                                                                        className="col-form-label"
                                                                    >
                                                                        First
                                                                        Name:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateFirstName(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.firstNameError}</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="message-text"
                                                                        className="col-form-label"
                                                                    >
                                                                        Last
                                                                        Name:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateLastName(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.lastNameError}</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Mobile
                                                                        No:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="mobileNo"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateMobileNo(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.mobileNoError}</p>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="message-text"
                                                                        className="col-form-label"
                                                                    >
                                                                        Address:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateAddress(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.addressError}</p>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Email:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateEmail(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.emailError}</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Company
                                                                        Name:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="name"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeComapanyName(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.companyNameError}</p>
                                                                </div>

                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Designation:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="mobileNo"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateDesignation(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.designationError}</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Department:
                                                                    </label>
                                                                    <input
                                                                        type="text"
                                                                        name="mobileNo"
                                                                        className="form-control"
                                                                        id="recipient-name"
                                                                        onChange={(
                                                                            e
                                                                        ) => {
                                                                            this.onChangeCandidateDepartment(
                                                                                e
                                                                            );
                                                                        }}
                                                                    />
                                                                    <p style={{color:'red'}}>{this.state.departmentError}</p>
                                                                </div>
                                                                <div className="form-group">
                                                                    <label
                                                                        htmlFor="recipient-name"
                                                                        className="col-form-label"
                                                                    >
                                                                        Upload File:
                                                                    </label>
                                                                    <TextField
                                                                        name="fileToUpload"
                                                                        size="small"
                                                                        type="file"
                                                                        variant="outlined"
                                                                        className="mr-3 ml-3 mt-1 inputField"
                                                                        onChange={this.handleInputChange}
                                                                    />
                                                                </div>
                                                            </form>
                                                        </div>

                                                        <div className="modal-footer">
                                                            <button
                                                                type="button"
                                                                className="btn btn-secondary"
                                                                data-dismiss="modal"
                                                            >
                                                                Close
                                                            </button>
                                                            <button
                                                                type="button"
                                                                className="btn btn-primary"
                                                                onClick={(
                                                                    e
                                                                ) => {
                                                                    this.submitFile(
                                                                        e
                                                                    );
                                                                }}
                                                                // disabled={
                                                                //     !this.state.newCandidate.firstName ||
                                                                //     !this.state.newCandidate.lastName ||
                                                                //     !this.state.newCandidate.companyName ||
                                                                //     !this.state.newCandidate.mobileNo ||
                                                                //     !this.state.newCandidate.address ||
                                                                //     !this.state.newCandidate.email ||
                                                                //     !this.state.newCandidate.designation ||
                                                                //     !this.state.newCandidate.department 
                                                                // }
                                                            >
                                                                Submit
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* Modal for update  starts here*/}

                                        {/* modal for update ends here */}
                                        <table
                                            id="example1"
                                            class="table table-bordered table-striped table-sortable"
                                        >
                                            <thead>
                                                <tr className="text-center">
                                                    <th colSpan="1">
                                                        id{" "}
                                                        <i class="fas fa-sort"></i>{" "}
                                                    </th>
                                                    <th>
                                                        First Name{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Last Name{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Company Name{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Mobile No{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Address{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Email{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Designation{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Department{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        Docs{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                    <th>
                                                        operation{" "}
                                                        <i class="fas fa-sort"></i>
                                                    </th>
                                                  
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.renderCandidatesData()}
                                                <div
                                                    className="modal fade"
                                                    id="update"
                                                    tabIndex={-1}
                                                    role="dialog"
                                                    aria-labelledby="exampleModalLabel"
                                                    aria-hidden="true"
                                                >
                                                    <div
                                                        className="modal-dialog"
                                                        role="document"
                                                    >
                                                        <div className="modal-content">
                                                            <div className="modal-header">
                                                                <h5
                                                                    className="modal-title"
                                                                    id="exampleModalLabel"
                                                                >
                                                                    New message
                                                                </h5>
                                                                <button
                                                                    type="button"
                                                                    className="close"
                                                                    data-dismiss="modal"
                                                                    aria-label="Close"
                                                                >
                                                                    <span aria-hidden="true">
                                                                        ×
                                                                    </span>
                                                                </button>
                                                            </div>
                                                            <div className="modal-body">
                                                                <form>
                                                                    <div className="form-group">
                                                                        <label
                                                                            htmlFor="recipient-name"
                                                                            className="col-form-label"
                                                                        >
                                                                            Recipient:
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            className="form-control"
                                                                            id="recipient-name"
                                                                        />
                                                                    </div>
                                                                    <div className="form-group">
                                                                        <label
                                                                            htmlFor="message-text"
                                                                            className="col-form-label"
                                                                        >
                                                                            Message:
                                                                        </label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            id="message-text"
                                                                            defaultValue={
                                                                                ""
                                                                            }
                                                                        />
                                                                    </div>
                                                                </form>
                                                            </div>
                                                            <div className="modal-footer">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-secondary"
                                                                    data-dismiss="modal"
                                                                >
                                                                    Close
                                                                </button>
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-primary"
                                                                >
                                                                    update
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                {/* /.col */}
                            </div>
                            {/* /.row */}
                        </div>
                        {/* /.container-fluid */}
                    </section>
                    {/* /.content */}
                    {this.renderViewModal()}
                    {this.renderUpdateModal()}
                </div>
                {/* /.content-wrapper */}
            </div>
        );
    }
}
